var React = require('react');

function IcChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.59 8.29498L12 12.875L7.41 8.29498L6 9.70498L12 15.705L18 9.70498L16.59 8.29498Z","fill":"currentColor"}));
}

IcChevronDown.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IcChevronDown;

IcChevronDown.default = IcChevronDown;
